// extracted by mini-css-extract-plugin
module.exports = {"root":"subfeatures_root__zx3wr","outer":"subfeatures_outer__2m5AB","handwritingWrapper":"subfeatures_handwritingWrapper__6zF1H","inner":"subfeatures_inner__YAteD"};